import React, { FC } from 'react';

import { i18n } from '../../../../../../../../helpers/i18n';
import { Heading } from '../../../../heading';
import css from '../styles.css';
import { OutputDeviceLevel } from './output-device-level';

export const OutputDeviceHeader: FC = () => {
    return (
        <div className={css.headingWrapper}>
            <Heading title={i18n('settings-v2', 'sound-speaker')} rightCustom={<OutputDeviceLevel />} />
        </div>
    );
};
